/* Habitat Collective: sticky add-to-cart bar for product pages */
if (!customElements.get('hc-sticky-atc')) {
  class HcStickyAtc extends HTMLElement {
    connectedCallback() {
      this.button = this.querySelector('[data-hc-sticky-button]');
      this.label = this.querySelector('[data-hc-sticky-label]');
      this.priceTarget = this.querySelector('[data-hc-sticky-price]');
      this.singleVariant = this.dataset.singleVariant === 'true';
      this.chooseLabel = this.dataset.chooseLabel || 'Select size';
      this.addLabel = this.dataset.addLabel || 'Add to cart';
      this.soldOutLabel = this.dataset.soldOutLabel || 'Sold out';
      this.interacted = false;

      if (!this.getMainButton()) return;

      this.button.addEventListener('click', this.onClick.bind(this));
      this.watchVisibility();
      this.watchPrice();
      this.watchButtonState();
      this.watchPicker();
      this.syncState();
    }

    getInfo() {
      return document.querySelector('.product__info-container');
    }

    getMainButton() {
      const info = this.getInfo();
      return info ? info.querySelector('product-form button[name="add"]') : null;
    }

    getPicker() {
      const info = this.getInfo();
      return info ? info.querySelector('variant-selects, variant-radios') : null;
    }

    onClick(event) {
      event.preventDefault();
      const main = this.getMainButton();
      if (!main) return;

      if (this.singleVariant || this.interacted) {
        if (main.disabled) return;
        main.click();
        return;
      }

      const picker = this.getPicker();
      const target = picker || main;
      const headerOffset = 90;
      const top = target.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      const firstInput = picker && picker.querySelector('input:not([disabled]), select');
      if (firstInput) setTimeout(() => firstInput.focus({ preventScroll: true }), 500);
    }

    watchVisibility() {
      const main = this.getMainButton();
      if (!('IntersectionObserver' in window)) {
        this.classList.add('is-visible');
        return;
      }
      this.io = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            this.querySelector('.hc-sticky').classList.toggle('is-visible', scrolledPast);
            this.querySelector('.hc-sticky').setAttribute('aria-hidden', scrolledPast ? 'false' : 'true');
            this.button.tabIndex = scrolledPast ? 0 : -1;
          });
        },
        { threshold: 0 }
      );
      this.io.observe(main);
    }

    copyPrice() {
      const info = this.getInfo();
      const source = info && info.querySelector('[id^="price-"]');
      if (source && this.priceTarget) this.priceTarget.innerHTML = source.innerHTML;
    }

    watchPrice() {
      this.copyPrice();
      const info = this.getInfo();
      if (!info) return;
      this.mo = new MutationObserver(() => {
        this.copyPrice();
        this.syncState();
      });
      this.mo.observe(info, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
    }

    watchButtonState() {
      document.addEventListener('change', (event) => {
        if (event.target.closest && event.target.closest('variant-selects, variant-radios')) {
          this.interacted = true;
          setTimeout(() => this.syncState(), 50);
        }
      });
    }

    watchPicker() {
      const picker = this.getPicker();
      if (!picker) this.singleVariant = true;
    }

    syncState() {
      const main = this.getMainButton();
      if (!main || !this.label) return;
      const disabled = main.disabled || main.getAttribute('aria-disabled') === 'true';
      if ((this.singleVariant || this.interacted) && disabled) {
        this.label.textContent = this.soldOutLabel;
        this.button.setAttribute('aria-disabled', 'true');
        this.button.classList.add('disabled');
      } else {
        this.label.textContent = this.singleVariant || this.interacted ? this.addLabel : this.chooseLabel;
        this.button.removeAttribute('aria-disabled');
        this.button.classList.remove('disabled');
      }
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this.mo) this.mo.disconnect();
    }
  }
  customElements.define('hc-sticky-atc', HcStickyAtc);
}
